import { useFocusEffect, useNavigation, useRoute } from "@react-navigation/native"
import React, { useCallback, useContext } from "react"
import { ParentLayoutContext } from "./ParentLayoutContext"
import { SubscriptionPortalScreen } from "../../../ports/primary/ui/screens/parent/Subscription/SubscriptionPortalScreen"

/**
 * Enveloppe du portail sur le design system : elle lit le contexte de la coquille (`ports/**` n'a
 * pas le droit d'importer `src/common/**`) et consomme les paramètres de route que le parcours de
 * résiliation pose en revenant ici.
 */
const ParentSubscriptionPortalScreen = () => {
    const navigation = useNavigation()
    const route = useRoute()
    const parentContext = useContext(ParentLayoutContext)
    const { selectedUser, openSupportChat } = parentContext || {}

    // L'intention « ouvre le support » posée par l'écran « Alternatives » du parcours de
    // résiliation : elle a besoin du contexte de la coquille, que l'écran ports ne voit pas.
    // Celle qui demande la pause est lue par l'écran ports lui-même.
    useFocusEffect(
        useCallback(() => {
            if (!route?.params?.openSupport) return
            openSupportChat?.()
            navigation.setParams({
                openSupport: undefined,
                supportIntent: undefined,
            })
        }, [route?.params?.openSupport, navigation, openSupportChat])
    )

    return (
        <SubscriptionPortalScreen
            selectedUser={selectedUser}
            onOpenSupport={openSupportChat}
        />
    )
}

export default ParentSubscriptionPortalScreen
